import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css`
  .faq-question {
    width: 100%;
    padding: 25px 0;

    &:active,
    &:hover {
      outline: none;
    }
  }

  .faq-question-item {
    margin-top: 8px;

    display: flex;
    margin-left: 16px;
    justify-content: space-between;
  }

  .faq-question-text {
    font-size: 20px;
    padding-right: 8px;
    margin: unset;
  }

  .down-arrow-wrapper {
    margin-right: 16px;
    transition: transform 0.3s ease-in-out;

    :global(svg) {
      width: 24px;
      height: 24px;
    }

    &.open {
      transform: rotate(180deg);
      position: relative;
      bottom: 8px;
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .faq-question-text {
      font-size: 16px;
      font-weight: 500;
    }

    .faq-answer-item {
      font-size: 16px;

      &.open {
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 20px;
        margin-right: 80px;
      }
    }
  }
`;
